import script from "./AnnouncementEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementEdit.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementEdit.vue?vue&type=style&index=0&id=60fab772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60fab772"]])

export default __exports__